module.exports = __webpack_public_path__ + "img/ctrl-canonical-stub-1.01c27441.svg";